import { EnergySwitchSteps } from 'components/common/energy-switch-steps/EnergySwitchSteps';
import { NsCaveat } from 'components/common/ns-caveat/NsCaveat';

export const evTariffCaveatTestId = 'evTariffCaveat';

const EvTariffInformationFooter = () => {
  return (
    <>
      <EnergySwitchSteps />
      <NsCaveat testId={evTariffCaveatTestId} heading="Legal Information" />
    </>
  );
};

export default EvTariffInformationFooter;
